// Module
var code = `<p class="tagline">{{text}}</p>
{{#article}}
<p>{{.*}}</p>
{{/article}}
`;
// Exports
module.exports = code;